import {
  SET_BUTTON_ELEMENT_TEXT,
  SET_BUTTON_ELEMENT_URL,
  SET_BUTTON_ELEMENT_TARGET,
  SET_BUTTON_ELEMENT_CORNER_RADIUS,
  SET_BUTTON_ELEMENT_WIDTH,
  SET_BUTTON_ELEMENT_PADDING,
} from './action-names';

export function setButtonElementText(data) {
  return {
    type: SET_BUTTON_ELEMENT_TEXT,
    ...data
  };
};

export function setButtonElementURL(data) {
  return {
    type: SET_BUTTON_ELEMENT_URL,
    ...data
  };
};

export function setButtonElementTarget(data) {
  return {
    type: SET_BUTTON_ELEMENT_TARGET,
    ...data
  };
};

export function setButtonElementCornerRadius(data) {
  return {
    type: SET_BUTTON_ELEMENT_CORNER_RADIUS,
    ...data
  };
};

export function setButtonElementWidth(data) {
  return {
    type: SET_BUTTON_ELEMENT_WIDTH,
    ...data
  };
};

export function setButtonElementPadding(data) {
  return {
    type: SET_BUTTON_ELEMENT_PADDING,
    ...data
  };
};




// WEBPACK FOOTER //
// ./app/header-builder/actions/button-element-actions.js